import { createContext, useContext } from "react";
import { type IGroupOrLabel, type ILogbook } from "src/interfaces";

export interface IGroupContext {
  selectedElement: IGroupOrLabel | null;
  handleAddElement: () => void;
  handleDeleteElement: (groupId: any) => void;
  handleEditElement: (data: any) => void;
  handleSelectElement: (group: any) => void;
  handleMoveLogbook: (logbook: ILogbook) => void;
  handleReset: () => void;
  elementsSection: {
    title: string;
    emptyMessage: string;
  };
  addButtonLabel: string;
}

const GroupContext = createContext<IGroupContext>({} as any);
interface Props {
  children: React.ReactNode;
  context: IGroupContext;
}
export const GroupProvider = ({ children, context }: Props) => {
  return (
    <GroupContext.Provider value={context}>{children}</GroupContext.Provider>
  );
};
export const useGroupContext = () => useContext(GroupContext);
